import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useGoalHttp } from '@/core/api/goals'
import { Goal, GoalPayload } from '@/core/models/goal'

export type GoalCollection = {
    data: Array<Goal>,
    meta?: MetaPayload,
    links?: any
}

const state: GoalCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const goalCollection: Module<GoalCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: GoalCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: GoalPayload) => {
                state.data.push(new Goal(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGoalHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: GoalCollection): GoalCollection => {
            return state
        }
    }
}